var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-card', {
    attrs: {
      "sectioned": ""
    }
  }, [_c('polaris-setting-action', [_c('template', {
    slot: "children"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('polaris-button', {
    attrs: {
      "primary": !_vm.enabled,
      "url": _vm.action.url,
      "accessibility-label": _vm.action.accessibilityLabel,
      "disabled": _vm.action.disabled,
      "destructive": _vm.action.destructive,
      "icon": _vm.action.icon
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    },
    slot: "action"
  }, [_vm._v("\n            " + _vm._s(_vm.enabled ? 'Disable' : 'Enable') + "\n        ")])], 2)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d0ec175", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0ec175","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisSettingToggle.vue
// module id = 148
// module chunks = 0